import { useEffect, useRef, useState } from 'react';

export default function BigensDemoVanilla() {
  const AGENT_ID = '9fbb4131-6c47-4cc2-9c71-3042ebb68762';
  const API_KEY = 'pawsf_adb0206c364f7aa5910f3217a2dca06f';
  const SITE_URL = 'https://quora-frontend-cl1.kinddesert-624c9557.brazilsouth.azurecontainerapps.io';

  const iframeRef = useRef(null);
  const [isChatOpen, setIsChatOpen] = useState(false);

  useEffect(() => {
    const handleMessage = (event) => {
      const iframe = iframeRef.current;
      if (!iframe) return;

      switch (event.data.type) {
        case "agent-chat-resize":
          iframe.style.width = event.data.width;
          iframe.style.height = event.data.height;
          iframe.style.bottom = event.data.bottom;
          iframe.style.right = event.data.right;
          iframe.style.borderRadius = event.data.borderRadius;
          break;

        case "agent-chat-opened":
          setIsChatOpen(true);
          break;

        case "agent-chat-closed":
          setIsChatOpen(false);
          break;

        case "agent-chat-ready":
          const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
                          || window.innerWidth <= 768;
          
          iframe.contentWindow.postMessage({
            type: 'parent-info',
            isMobile: isMobile,
            screenWidth: window.innerWidth
          }, '*');
          break;
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Demo Bigens
        </h1>
        <p className="text-lg text-gray-600">
          Esta é uma página de demonstração do chat widget para Bigens.
        </p>
      </div>

      <iframe
        ref={iframeRef}
        id="agent-chat-widget"
        src={`${SITE_URL}/agent-chat/iframe/${AGENT_ID}?apiKey=${API_KEY}`}
        style={{
          position: 'fixed',
          border: 'none',
          zIndex: 9999,
          bottom: '20px',
          right: '20px',
          transition: 'all 0.3s ease',
          borderRadius: '20px',
        }}
        allow="fullscreen"
        allowFullScreen
      />
    </div>
  );
}